// cSpell:ignore sigmarite

import {
  BlazeOfGlory,
  HallowedScrolls,
  MorrdaSTalon,
  NullPendant,
  QuicksilverDraught,
  ShieldOfAzyr,
  StormcastEternalsVigilantBrotherhood,
  StormCharge,
  StrikeWhereNeeded
} from "whole-shared";

import type { ClientAbility } from "../../rules";
import type { ClientSpearheadArmy } from "./rules";

export const ClientShieldOfAzyr: ClientAbility = {
  ...ShieldOfAzyr,
  declare:     "Pick a friendly unit",
  description: "Roaring oaths to Sigmar, these warriors are surrounded by an aura of divine protection",
  effect:      (
    <>
      Until the start of your next turn, that unit has <b>Ward (5+)</b>
    </>
  ),
  name: "SHIELD OF AZYR"
};

export const ClientStormCharge: ClientAbility = {
  ...StormCharge,
  declare:     "Pick a friendly unit that is not in combat",
  description: "These warriors are driven forward by their faith, ever eager to bring Sigmar's holy retribution to his enemies",
  effect:      (
    <>
      That unit can use <b>Charge</b> abilities this turn even if it used a <b>Run</b> ability in the same turn
    </>
  ),
  name: "STORM CHARGE"
};

export const ClientHallowedScrolls: ClientAbility = {
  ...HallowedScrolls,
  description: "Sacred parchments inscribed with Sigmarite blessings adorn this warrior",
  effect:      (
    <>
      Your general has <b>Ward (5+)</b>
    </>
  ),
  name: "HALLOWED SCROLLS"
};

export const ClientMorrdaSTalon: ClientAbility = {
  ...MorrdaSTalon,
  description: "Enemies of the God-King know this weapon by name and fear its keen blade",
  effect:      (
    <>
      Your general's <b>Hallowed Greataxe</b> has <b>Crit (Mortal)</b>
    </>
  ),
  name: "MORRDA'S TALON"
};

export const ClientQuicksilverDraught: ClientAbility = {
  ...QuicksilverDraught,
  description: "This potion lends uncanny speed to the one who imbibes it",
  effect:      (
    <>
      Your general has <b>Strike-first</b> this phase
    </>
  ),
  name: "QUICKSILVER DRAUGHT"
};

export const ClientNullPendant: ClientAbility = {
  ...NullPendant,
  declare:     "Roll a dice for each enemy unit contesting the same objective as your general",
  description: "This dark amulet holds magic within that can sap the resolve of the enemy",
  effect:      "On a 2+, subtract the roll from the control score of that enemy unit this turn",
  name:        "NULL PENDANT"
};

export const ClientStrikeWhereNeeded: ClientAbility = {
  ...StrikeWhereNeeded,
  description:
    "Though often outnumbered by their foes, the Stormcast Eternals are accustomed to fighting on many fronts and focusing their efforts where they will have the greatest impact",
  effect: (
    <>
      No mortal damage is inflicted on that unit by that <b>Retreat</b> ability. In addition, that unit can still use <b>Charge</b> abilities this
      turn even though it used a <b>Retreat</b> ability
    </>
  ),
  name:   "STRIKE WHERE NEEDED",
  usedBy: (
    <>
      The unit using that <b>Retreat</b> ability
    </>
  )
};

export const ClientBlazeOfGlory: ClientAbility = {
  ...BlazeOfGlory,
  declare: "Pick a friendly unit that is in combat",
  description:
    "As these warriors are struck down, Sigmar's holy lightning wreaks devastation around them before they are called back to the heavens to be Reforged",
  effect: (
    <>
      Until the end of the phase, each time a model in that unit is slain, make a <b>vengeance roll</b> of D6. On a 4+, inflict 1 mortal damage on an
      enemy unit in combat with that unit
    </>
  ),
  name: "BLAZE OF GLORY"
};

export const ClientStormcastEternalsVigilantBrotherhood: ClientSpearheadArmy = {
  ...StormcastEternalsVigilantBrotherhood,
  battleTraits:      [ClientShieldOfAzyr, ClientStormCharge],
  enhancements:      [ClientHallowedScrolls, ClientMorrdaSTalon, ClientQuicksilverDraught, ClientNullPendant],
  name:              "VIGILANT BROTHERHOOD",
  regimentAbilities: [ClientStrikeWhereNeeded, ClientBlazeOfGlory]
};
